export const safeSQLStringRegexp = /^[().@_A-z0-9]*((-|\s)*[\s().@_A-z0-9])*$/;
export const phoneRegexp = /^(?:\+|\d)[\d\s-]{8,13}\d$/;
export const emailRegexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const linkRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
export const invalidNumberInputChars = ["-", "+", "e", "E"];
